import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from './__root';

/**
 * The `/` route exists only as a redirect to `/email-accounts`. We forward
 * any search params untouched so callers that land on `/` from OAuth flows
 * (or legacy bookmarks) keep their state through the redirect. `replace: true`
 * keeps `/` out of the browser history.
 *
 * `beforeLoad` runs ahead of the loader and component, so this throw short-
 * circuits the route render — the `component` is never invoked at runtime
 * but TanStack Router still requires the prop, so we pass a no-op.
 */
export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/email-accounts', search, replace: true });
  },
  component: () => null,
});
